"use client"

import { useState, useRef, useEffect } from "react" // Import useEffect
import "../styles/video-grid.css"
import award from "../assets/videos/award.mp4"
import awardImg from '../assets/images/gal2.png'
import mainmg1 from '../assets/images/mainvid.png'
import mainvid from '../assets/videos/mainvid.mp4'
import chilpng from '../assets/images/chil.png'
import chilVid from '../assets/videos/haropromo1.mp4'
import award2 from '../assets/images/award2.png'
import award2Vid from '../assets/videos/award3.mp4'
import groundImg from '../assets/images/groundEx.png'
import cocoImg from '../assets/images/cocoEX.png'
import groundVid from '../assets/videos/ground.mp4'
import cocoVid from '../assets/videos/coco.mp4'


const VideoGrid = ({ videos = [] }) => {
  const [activeVideo, setActiveVideo] = useState(null)
  const videoRefs = useRef({})
  const videoGridRef = useRef(null) // Ref for the video grid container

  // Sample video data if none provided
  const defaultVideos = [
    {
      id: "v1",
      title: "Fitness Routine",
      thumbnail: awardImg,
      videoUrl: award,
      duration: "0:49",
      type: "local",
    },
    {
      id: "v2",
      title: "Fitness Routine",
      thumbnail: mainmg1,
      videoUrl: mainvid,
      duration: "0:36",
      type: "local",
    },
    {
      id: "v3",
      title: "Fitness Routine",
      thumbnail: chilpng,
      videoUrl: chilVid,
      duration: "0:31",
      type: "local",
    },
    {
      id: "v4",
      title: "Tech Review",
      thumbnail: award2,
      videoUrl: award2Vid,
      type: "local",
    },
    {
      id: "v5",
      title: "Music Production",
      thumbnail: groundImg,
      videoUrl: groundVid,
      type: "local",
    },
    {
      id: "v6",
      title: "Documentary: Ocean Life",
      thumbnail: cocoImg,
      videoUrl: cocoVid,
      category: "Documentary",
      type: "local",
    },
    {
      id: "yt1",
      title: "YouTube Video 1",
      thumbnail: "https://img.youtube.com/vi/kSChxW6bWo0/maxresdefault.jpg",
      youtubeId: "kSChxW6bWo0",
      type: "youtube",
    },
    {
      id: "yt2",
      title: "YouTube Video 2",
      thumbnail: "https://img.youtube.com/vi/_RQBJrtRrM0/maxresdefault.jpg",
      youtubeId: "_RQBJrtRrM0",
      type: "youtube",
    },
    {
      id: "yt3",
      title: "YouTube Video 3",
      thumbnail: "https://img.youtube.com/vi/S6PbjLaUGmM/maxresdefault.jpg",
      youtubeId: "S6PbjLaUGmM",
      type: "youtube",
    },
  ]

  const videosToRender = videos.length > 0 ? videos : defaultVideos

  const handleVideoClick = (videoId) => {
    if (activeVideo === videoId) {
      setActiveVideo(null)
    } else {
      setActiveVideo(videoId)

      // Pause all videos
      Object.keys(videoRefs.current).forEach((key) => {
        if (videoRefs.current[key] && key !== videoId) {
          videoRefs.current[key].pause()
        }
      })
    }
  }

  // Effect to handle clicks outside the video grid
  useEffect(() => {
    const handleClickOutside = (event) => {
      // If the click is outside the video grid container and a video is active
      if (videoGridRef.current && !videoGridRef.current.contains(event.target) && activeVideo) {
        // Pause the active video if it exists
        if (videoRefs.current[activeVideo]) {
          videoRefs.current[activeVideo].pause();
        }
        setActiveVideo(null); // Deactivate the video
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeVideo]); // Re-run effect if activeVideo changes

  return (
    <div className="video-grid-container" ref={videoGridRef}> {/* Attach ref here */}
      <h2 className="video-grid-title">Featured Videos</h2>

      <div className="video-grid">
        {videosToRender.map((video, index) => (
          <div
            key={video.id}
            className={`video-item ${index === 0 ? "featured" : ""} ${activeVideo === video.id ? "active" : ""}`}
            onClick={() => handleVideoClick(video.id)}
          >
            {video.type === "youtube" ? (
              <>
                <div className="video-thumbnail">
                  <img src={video.thumbnail || "/placeholder.svg"} alt={video.title} />
                  <div className="video-play-button">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 5V19L19 12L8 5Z" fill="currentColor" />
                    </svg>
                  </div>
                </div>
                {activeVideo === video.id && (
                  <div className="video-player youtube-player">
                    <div className="youtube-container">
                      <iframe
                        width="100%"
                        height="100%"
                        src={`https://www.youtube.com/embed/${video.youtubeId}?autoplay=1`}
                        title={video.title}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>
                <div className="video-thumbnail">
                  <img src={video.thumbnail || "/placeholder.svg"} alt={video.title} />
                  <div className="video-duration">{video.duration}</div>
                  <div className="video-play-button">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 5V19L19 12L8 5Z" fill="currentColor" />
                    </svg>
                  </div>
                </div>
                {activeVideo === video.id && (
                  <div className="video-player">
                    <video ref={(el) => (videoRefs.current[video.id] = el)} controls autoPlay src={video.videoUrl}>
                      Your browser does not support the video tag.
                    </video>
                  </div>
                )}
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default VideoGrid